(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_grid_new"] && !Shopify.designMode) return;
  try {
    
  (function () {
    try {
      if (window.__customCardSliderReady) return;
      window.__customCardSliderReady = true;

      function idx(slider) {
        var t = slider.querySelector('.custom-card-slider__track');
        return t && t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0;
      }

      function goTo(slider, i, smooth) {
        var t = slider.querySelector('.custom-card-slider__track');
        if (!t) return;
        var n = t.children.length;
        if (n < 2) return;
        i = ((i % n) + n) % n;
        t.scrollTo({ left: i * t.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      }

      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.custom-card-slider__arrow') : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var slider = btn.closest('.custom-card-slider');
        if (!slider) return;
        slider.setAttribute('data-interacted', 'true');
        goTo(slider, idx(slider) + parseInt(btn.getAttribute('data-dir'), 10), true);
      }, true);

      document.addEventListener('touchstart', function (e) {
        var slider = e.target.closest ? e.target.closest('.custom-card-slider') : null;
        if (slider) slider.setAttribute('data-interacted', 'true');
      }, { passive: true });

      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        document.addEventListener('mouseover', function (e) {
          var media = e.target.closest ? e.target.closest('.custom-product-card__media') : null;
          if (!media || media.contains(e.relatedTarget)) return;
          var slider = media.querySelector('.custom-card-slider');
          if (!slider || slider.getAttribute('data-hover') !== 'true' || slider.getAttribute('data-interacted') === 'true') return;
          goTo(slider, 1, false);
        });

        document.addEventListener('mouseout', function (e) {
          var media = e.target.closest ? e.target.closest('.custom-product-card__media') : null;
          if (!media || media.contains(e.relatedTarget)) return;
          var slider = media.querySelector('.custom-card-slider');
          if (!slider) return;
          slider.removeAttribute('data-interacted');
          goTo(slider, 0, false);
        });
      }
    } catch (err) {
      console.warn('custom-card-slider error', err);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
